module.exports = __webpack_public_path__ + "static/Emerald_City_Tour_thumbnail.954527e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Emerald_City_Tour_thumbnail.jpg
// module id = 446
// module chunks = 35783957827783